export default "__VITE_ASSET__da85ffb9__"